import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeUrl } from '@angular/platform-browser';
import DOMPurify from 'dompurify';

@Pipe({
  name: 'dOMSafe',
})
export class DOMSafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}
  public transform(value: any, type: string): SafeHtml | SafeUrl {
    const sanitizedContent = DOMPurify.sanitize(value);
    switch (type) {
      case 'html':
        return this.sanitizer.sanitize(SecurityContext.HTML, value);
      case 'url':
        return this.sanitizer.bypassSecurityTrustUrl(value);
      case 'stylesafehtml':
        return this.sanitizer.bypassSecurityTrustHtml(sanitizedContent);
      default:
        throw new Error('Invalid safe type specified : ${type}');
    }
  }
}
